import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  verifiedPrimaryUserId: null,
  loading: false,
  needToLogin: null,
  error: null,
};

export const partnerVerification = createSlice({
  name: 'partnerVerification',
  initialState,
  reducers: {
    setVerifiedPrimaryUserId: (state, action) => {
      state.verifiedPrimaryUserId = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setNeedToLogin: (state, action) => {
      state.needToLogin = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setVerifiedPrimaryUserId, setLoading, setNeedToLogin, setError } =
  partnerVerification.actions;

export default partnerVerification.reducer;
